import React from "react";
import { useDispatch } from "react-redux";
import { setPageHeadingAction } from "@src/layout/store/actions";
import { t } from "i18next";
import FreeContentPage from "@src/components/Tabs/Content/components/FreeContent/FreeContentPage";

const CourseFreeContent = () => {
  // REDUX DISPATCH
  const dispatch = useDispatch();

  // SETTTING PAGE TITLE ON PAGE MOUNT
  React.useEffect(() => {
    dispatch(
      setPageHeadingAction(
        t("pages.courseId.freeContent.index.allFreeContent", "All Free Content")
      )
    );
    return () => {
      dispatch(setPageHeadingAction());
    };
  }, []);

  return <FreeContentPage />;
};

// DEFINING LAYOUT PROPERTIES FOR THIS PAGE
CourseFreeContent.getLayoutProps = () => ({
  accent: true,
  blockHeader: true,
});

export default CourseFreeContent;
